<template>
	<div class="all-trademarks" data-aos="fade-up">
		<div class="all-trademarks.container">
			<h3>全部商标分类</h3>
			<ul>
				<li v-for="(trade,index) in allTrademarks" :key="index">
					<a target="_blank" href="javascript:;" @click="goDetail(index + 1)">
						<span>{{trade.attribute_name}} <i v-show="trade.type == 2"><img src="../assets/trademarks/hot.png"></i> </span>
						<span>{{trade.number}}</span>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
                 allTrademarks:[]
			}
		},
		methods:{
			initTradeMarks(){
				this.http.get("IPR_Trademark_Attribute?all=1").then(res => {
					this.allTrademarks = res.data.data
				})
			},
			goDetail(index){
				let routeUrl = this.$router.resolve({
					path: 'Trademark',
					query: {
						id: index
					}
				});
				window.open(
				  location.pathname + "#" + routeUrl.resolved.fullPath,
				  "_blank"
				); //线上发布用
				
			}
		},
		created(){
			this.initTradeMarks()
		}
	}
</script>

<style lang="scss">
	@include component(all-trademarks) {
		width: 1200px;
		margin: 0 auto;
		margin-top: 60px;
		border-top: 8px solid rgba(244, 114, 39, 1);
		height: 500px;
		color: #333;
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
		background: #fff;

		@include part(container) {
			padding-top: 28px;
			padding-left: 20px;
			padding-right: 20px;

			h3 {
				font-size: 24px;
				margin: 0;
				text-align: left;
			}
			ul{
				width: 100%;
				margin-top: 20px;
				//border: 1px solid red;
				display: flex;
				align-items: center;
				justify-content: flex-start;
				flex-wrap: wrap;
				border-collapse: collapse;
				border-spacing: 0px;
				border-top: 1px solid #F2F2F2;
				border-left:1px solid #F2F2F2;
				li{
					width: calc(100% / 5);
					height: 42px;
					line-height:42px;
					border-right: 1px solid #F2F2F2;
					border-bottom: 1px solid #F2F2F2;;
				    a{
						display: inline-block;
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						padding: 0 17px;
						color:#333;
						font-size:15px;
						span{
							display: inline-block;
							width: 80%;
							text-overflow: ellipsis;
							overflow: hidden;
							white-space: nowrap;
							text-align:left;
							&:nth-child(1){
								position:relative;
								
							}
							&:nth-child(2){
								width: 30%;
								color: #CCCCCC;
								text-align: right;
							}
							
						}
					}
				&:hover{
					border: 1px solid #F47227;
					box-shadow:0px 0px 10px 0px rgba(244,114,39,0.2);
				}

					
				}
			}


		}
	
	}
</style>
